(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class CFLongevityStickyHeader
  extends HTMLElement {

  constructor() {

    super();

  }


  connectedCallback() {

    this.header =
      document.querySelector(
        '.section-header'
      );


    if (!this.header) return;


    this.headerIsAlwaysSticky =
      this.getAttribute(
        'data-sticky-type'
      ) === 'always' ||

      this.getAttribute(
        'data-sticky-type'
      ) === 'reduce-logo-size';


    this.headerBounds = {};


    this.setHeaderHeight();


    window
      .matchMedia(
        '(max-width: 990px)'
      )
      .addEventListener(
        'change',
        this.setHeaderHeight
          .bind(this)
      );


    if (
      this.headerIsAlwaysSticky
    ) {

      this.header
        .classList
        .add(
          'shopify-section-header-sticky'
        );

    }


    this.currentScrollTop = 0;

    this.predictiveSearch =
      this.querySelector(
        'predictive-search'
      );


    this.onScrollHandler =
      this.onScroll.bind(this);


    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      false
    );


    this.createObserver();

  }


  setHeaderHeight() {

    if (!this.header) return;


    document
      .documentElement
      .style
      .setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );

  }


  disconnectedCallback() {

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );

  }


  createObserver() {

    const observer =
      new IntersectionObserver(
        (entries) => {

          this.headerBounds =
            entries[0]
              .intersectionRect;

          observer.disconnect();

        }
      );


    observer.observe(
      this.header
    );

  }


  onScroll() {

    const scrollTop =
      window.pageYOffset ||

      document
        .documentElement
        .scrollTop;


    if (
      this.predictiveSearch &&
      this.predictiveSearch.isOpen
    ) {

      return;

    }


    if (
      scrollTop >
        this.currentScrollTop &&

      scrollTop >
        this.headerBounds.bottom
    ) {

      this.header
        .classList
        .add(
          'scrolled-past-header'
        );


      if (
        !this.headerIsAlwaysSticky
      ) {

        this.header
          .classList
          .add(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky'
          );

      }


    } else if (

      scrollTop <
        this.currentScrollTop &&

      scrollTop >
        this.headerBounds.bottom

    ) {

      this.header
        .classList
        .add(
          'scrolled-past-header',
          'shopify-section-header-sticky'
        );


      this.header
        .classList
        .remove(
          'shopify-section-header-hidden'
        );


    } else if (

      scrollTop <=
        this.headerBounds.top

    ) {

      if (
        !this.headerIsAlwaysSticky
      ) {

        this.header
          .classList
          .remove(
            'shopify-section-header-hidden',
            'shopify-section-header-sticky',
            'scrolled-past-header'
          );

      }

    }


    this.currentScrollTop =
      scrollTop;

  }

}


if (
  !customElements.get(
    'sticky-header'
  )
) {

  customElements.define(
    'sticky-header',
    CFLongevityStickyHeader
  );

}


  } catch(e) { console.error(e); }
})();
})();
